/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';
import { useAuthContext } from 'contexts/AuthContext';
import { useAccessToken } from '@robinpowered/dashboard-apps-common';
import { config } from 'config';

export const useIntercom = (): void => {
  const { loading, error, currentUser } = useAuthContext();
  const { env, dashboardApiUrl, sessionCookieName, robinIntercomAppId } =
    config;
  const { accessToken } = useAccessToken(sessionCookieName);

  useEffect(() => {
    if (env === 'development' || !robinIntercomAppId) {
      return;
    }

    if (!loading && !error && currentUser && accessToken) {
      const initIntercom = async (): Promise<void> => {
        if (typeof (window as any).Intercom !== 'function') {
          return;
        }

        let userHash: string | undefined;
        try {
          const response = await fetch(
            `${dashboardApiUrl}/users/profile/verify`,
            {
              headers: {
                Authorization: `Access-Token ${accessToken}`,
              },
            }
          );
          if (response.ok) {
            const result = await response.json();
            userHash =
              typeof result?.data?.hash === 'string'
                ? result.data.hash
                : undefined;
          }
        } catch {
          // Skip booting to avoid Invalid user_hash
          return;
        }

        if (!userHash) {
          return;
        }

        (window as any).Intercom('boot', {
          app_id: robinIntercomAppId,
          name: currentUser?.name,
          user_id: currentUser?.id,
          user_hash: userHash,
          hide_default_launcher: true,
          custom_launcher_selector: '#robinSupportLink',
          widget: {
            activator: '#intercom-feedback',
          },
        });
      };
      initIntercom();
    }
  }, [
    currentUser,
    error,
    loading,
    accessToken,
    env,
    dashboardApiUrl,
    robinIntercomAppId,
  ]);
};
